import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {NexioResponse, Payment} from '../../graphql/payments.datatypes';


export interface ProcessPaymentInput {
    data: {
        token: string
        amount: number
        paymentType: string
    }
}

interface ProcessPaymentData {
    processPayment: NexioResponse
}

export const PROCESS_PAYMENT_MUTATION = gql`
    mutation processPayment($data: ProcessPaymentInput!) {
        processPayment(data: $data) {
            status
            data
            error
        }
    }
`;

export const processPayment = () => useMutation<ProcessPaymentData, ProcessPaymentInput>(
    PROCESS_PAYMENT_MUTATION,
);

export default processPayment;
